import React from "react";
import BlueHeading from "../other/common/BlueHeading";
import oneImg from "../../assets/images/webp/other/one.webp";
import twoImg from "../../assets/images/webp/other/two.webp";
import threeImg from "../../assets/images/webp/other/three.webp";
import fourImg from "../../assets/images/webp/other/four.webp";
import fiveImg from "../../assets/images/webp/other/five.webp";
import roadMapImg from "../../assets/images/webp/other/road-map.webp";

const WhyThisBook = () => {
  return (
    <>
      <div className="py-[140px] px-4  max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        <div className="flex items-center justify-center flex-col">
          <BlueHeading text="Why This Book" />
          <h2 className="text-[#001A3D] text-[50px] max-xl:text-5xl max-lg:text-4xl max-md:text-3xl font-bold ff-jakarta leading-[120%] pb-[86px] max-lg:pb-14 max-md:pb-10 text-center">
            Why This Book Will Change Your Life
          </h2>

          {/* Roadmap for smaller screens (Before md:) */}
          <div className="md:hidden">
            {/* Roadmap Container */}
            <div className="relative w-full flex flex-col items-center space-y-12 max-sm:space-y-6">
              {/* Step 1 */}
              <div className="flex flex-col items-center">
                <div className="w-[60px] h-[60px] rounded-full bg-[#001A3D] flex items-center justify-center text-white text-lg font-bold">
                  <img
                    src={oneImg}
                    width={50}
                    height={50}
                    alt="icon"
                    className="w-full max-w-[37px] pointer-events-none"
                  />
                </div>
                <p className="text-[#001A3D] font-semibold text-center mt-3">
                  Practical and deep insights from years of experience
                </p>
              </div>
              {/* Line connecting */}
              <div className="w-[2px] h-[40px] bg-[#001A3D] mx-auto"></div>

              {/* Step 2 */}
              <div className="flex flex-col items-center">
                <div className="w-[60px] h-[60px] rounded-full bg-[#001A3D] flex items-center justify-center text-white text-lg font-bold">
                  <img
                    src={twoImg}
                    width={50}
                    height={50}
                    alt="icon"
                    className="w-full max-w-[37px] pointer-events-none"
                  />
                </div>
                <p className="text-[#001A3D] font-semibold text-center mt-3">
                  Simple but powerful mental tools
                </p>
              </div>
              {/* Line connecting */}
              <div className="w-[2px] h-[40px] bg-[#001A3D] mx-auto"></div>

              {/* Step 3 */}
              <div className="flex flex-col items-center">
                <div className="w-[60px] h-[60px] rounded-full bg-[#001A3D] flex items-center justify-center text-white text-lg font-bold">
                  <img
                    src={threeImg}
                    width={50}
                    height={50}
                    alt="icon"
                    className="w-full max-w-[37px] pointer-events-none"
                  />
                </div>
                <p className="text-[#001A3D] font-semibold text-center mt-3">
                  Step-by-step techniques to upgrade your mindset
                </p>
              </div>
              {/* Line connecting */}
              <div className="w-[2px] h-[40px] bg-[#001A3D] mx-auto"></div>

              {/* Step 4 */}
              <div className="flex flex-col items-center">
                <div className="w-[60px] h-[60px] rounded-full bg-[#001A3D] flex items-center justify-center text-white text-lg font-bold">
                  <img
                    src={fourImg}
                    width={50}
                    height={50}
                    alt="icon"
                    className="w-full max-w-[37px] pointer-events-none"
                  />
                </div>
                <p className="text-[#001A3D] font-semibold text-center mt-3">
                  Based on real-life experiments and success stories
                </p>
              </div>
              {/* Line connecting */}
              <div className="w-[2px] h-[40px] bg-[#001A3D] mx-auto"></div>

              {/* Step 5 */}
              <div className="flex flex-col items-center">
                <div className="w-[60px] h-[60px] rounded-full bg-[#001A3D] flex items-center justify-center text-white text-lg font-bold">
                  <img
                    src={fiveImg}
                    width={50}
                    height={50}
                    alt="icon"
                    className="w-full max-w-[37px] pointer-events-none"
                  />
                </div>
                <p className="text-[#001A3D] font-semibold text-center mt-3">
                  Written in an easy, conversational tone
                </p>
              </div>
            </div>
          </div>

          {/* Existing Desktop Roadmap (after md:) */}
          <div className="relative max-w-[1048px] max-md:hidden  mx-auto mt-10">
            <img
              src={roadMapImg}
              alt="road-map"
              width={1048}
              height={285}
              className="w-full max-w-[1048px] h-[285px]"
            />
            <p className="font-semibold text-sm leading-[19.31px] text-[#001A3D] absolute max-w-[133px] text-center top-[45%] left-[2%]">
              Practical and deep insights from years of experience
            </p>
            <p className="font-semibold text-sm leading-[19.31px] text-[#001A3D] text-center absolute max-w-[180px] top-[72%] left-[19%]">
              Simple but powerful mental tools
            </p>
            <p className="font-semibold text-sm leading-[19.31px] text-[#001A3D] text-center absolute max-w-[163px] left-[40%] top-[55%] -translates-x-1/2 -translate-y-1/2">
              Step-by-step techniques to upgrade your mindset
            </p>
            <p className="font-semibold text-sm leading-[19.31px] text-[#001A3D] text-center absolute max-w-[161px] bottom-[9%] right-[20%]">
              Based on real-life experiments and success stories
            </p>
            <p className="font-semibold text-sm leading-[19.31px] text-[#001A3D] text-center absolute max-w-[149px] right-0 bottom-[35%]">
              Written in an easy, conversational tone
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default WhyThisBook;
